// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"14":"18665381","439":"eab23903","533":"36ed7d2f"}[chunkId] + ".chunk.css";
};